import { render, staticRenderFns } from "./ExpandItem.vue?vue&type=template&id=5a61dd5e&scoped=true"
import script from "./ExpandItem.vue?vue&type=script&lang=js"
export * from "./ExpandItem.vue?vue&type=script&lang=js"
import style0 from "./ExpandItem.vue?vue&type=style&index=0&id=5a61dd5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61dd5e",
  null
  
)

export default component.exports